export default __webpack_public_path__ + "static/media/harley.png.webp";